import Vue from 'vue';
import vuetify from '@/plugins/vuetify';
import store from '@/store';
import router from '@/router'
import 'es6-promise/auto';
import App from "@/App";
import { mapActions } from 'vuex';

Vue.config.productionTip = false;

new Vue({
  el: '#app',
  vuetify,
  store,
  router,
  render: h => h(App),
  created() {
    this.init(this.$route.query)
  },
  methods: {
    ...mapActions(['init']),
  },
})
